// app/javascript/controllers/chat_sizing_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    // hard cap so guest/admin look identical even if columns differ
    hardCap: Number,         // e.g. 560
    sidePadding: Number      // container horizontal padding in px
  }

  connect() {
    // defaults
    if (this.hardCapValue == null)   this.hardCapValue = 560
    if (this.sidePaddingValue == null) this.sidePaddingValue = 24 // matches p-3 (~12px each side) * 2

    this.recalc = this.recalc.bind(this)

    // Recalc now
    this.recalc()

    // Recalc when container resizes
    this.ro = new ResizeObserver(this.recalc)
    this.ro.observe(this.element)

    // Recalc when images load (bubbles may reflow)
    this.io = new MutationObserver(() => {
      // add load listeners for any newly-added images
      this.element.querySelectorAll("img[data-chat-image]:not([data-size-bound])").forEach(img => {
        img.addEventListener("load", this.recalc, { once: true })
        img.dataset.sizeBound = "1"
      })
    })
    this.io.observe(this.element, { childList: true, subtree: true })

    // initial image listeners (existing DOM)
    this.element.querySelectorAll("img[data-chat-image]:not([data-size-bound])").forEach(img => {
      img.addEventListener("load", this.recalc, { once: true })
      img.dataset.sizeBound = "1"
    })
  }

  disconnect() {
    this.ro?.disconnect()
    this.io?.disconnect()
  }

  recalc() {
    // available width inside the scroll area
    const inner = this.element.clientWidth - this.sidePaddingValue
    // choose a consistent bubble max width across admin/guest
    const target = Math.min(this.hardCapValue, inner)
    this.element.style.setProperty("--chat-bubble-max-w", `${target}px`)

    // optional: nudge autoscroll after reflow
    document.dispatchEvent(new Event("turbo:before-stream-render"))
  }
}
